import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_SITE_LINK, EDIT_SITE_LINK, CREATE_SITE_LINK } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteSiteLink(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_SITE_LINK}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editSiteLink(sendingData, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_SITE_LINK}`, sendingData, configReq(token));
}

/** Keeps the existing POST request and response contract. */
export function createSiteLink(sendingData, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_SITE_LINK}`, sendingData, configReq(token));
}
